const en = {
  unlimited_offer_step: ' Offer',
  unlimited_id_step: 'Verification',
  unlimited_group_step: 'Group',
  unlimited_installation_step: 'Installation',
  unlimited_summary_step: 'Finalization',
  unlimited_offer_description:
    'New! All family members benefit more together. You are at your best when you are in a group. Now all fixed and cellular services with a single offer.',
  unlimited_my_offer: 'Shtëpia Jonë',
  unlimited_family_offer: 'Family Offer',
  unlimited_end_of_offer: 'from the end of the offer',
  unlimited_offer_title: 'Group Offer',
  unlimited_offer_subtitle:
    'Choose the recommendation or create the offer you need',
  unlimited_offer_pay_period: '%1$s %1$s / month',
  unlimited_cart_details_none_selected:
    'You must choose your tariff plan, Vodafone Giga Fibra speed and members.',
  unlimited_offer_select_button: 'Continue with this bundle',
  unlimited_coverage_title: 'Verify coverage',
  unlimited_coverage_subtitle:
    'Search your address and verify coverage for fixed internet service installation',
  unlimited_processing: 'Processing Data',
  unlimited_exceeded_slots:
    '* You have exceeded the number of members in your group.',
  unlimited_leave_title: 'Leave Group',
  unlimited_leave_heading:
    'Are you sure you want to leave group? Careful! You will pay your own bill if your confirm',
  unlimited_my_members: 'My Group',
  unlimited_my_members_short: 'Group Members',
  unlimited_add_member_number_input: 'Member number',
  unlimited_member_description: 'Manage easily your group members',
  unlimited_group_plan: 'Group Plan',
  unlimited_pending_status: 'Waiting',
  unlimited_add_member_input: 'Add member',
  unlimited_add_member_info:
    'You can add up to %1$s different numbers as part of your group.',
  unlimited_leave_group_button: 'Leave group',
  unlimited_leave_group_explain: 'You can leave group after %1$s',
  unlimited_continue: 'Continue',
  unlimited_back: 'Back',
  unlimited_notify_when_leave:
    'The group administrator will be notified for your request ...',
  unlimited_leave_group_title: 'Are you sure you want to leave group ?',
  unlimited_included_in_offer: 'Included in your plan',
  unlimited_kick_member_title: 'Remove member',
  unlimited_kick_member_heading:
    'Are you sure you want to remove member %1$s from the group?',
  unlimited_kick_member_sub_heading:
    '%1$s will be notified with an SMS for your request',
  unlimited_add_member_title: 'Add a new member',
  unlimited_add_member_heading:
    'Are you sure you want to add number %1$s in your group?',
  unlimited_view_details: 'View details',
  unlimited_no_slots_selected:
    "You haven't selected the members option, but you can continue with the offer and then add to group management.",
  unlimited_id_title: 'Enter your ID',
  unlimited_id_description:
    'Enter the personal 10 digit number of the identity card',
  unlimited_next_step_button: 'Continue',
  unlimited_id_form_title: 'Photo ID',
  unlimited_id_form_subtitle: 'Verify Identity ',
  unlimited_id_upload_description:
    'Enter the 10-digit number of the identity card and take a photo of it to verify the registration data at Vodafone',
  unlimited_id_upload_button: 'Photograph ID',
  unlimited_id_uploaded_button: 'ID pictures have been uploaded',
  unlimited_id_personal_number_label: 'Personal Number',
  unlimited_id_name_label: 'Name',
  unlimited_id_email_label: 'Email',
  unlimited_id_surname_label: 'Surname',
  unlimited_id_country_label: 'Issuing Country',
  unlimited_id_month_label: 'Month',
  unlimited_expiration_month_label: 'Expiration Month',
  unlimited_id_year_label: 'Year',
  unlimited_expiration_year_label: 'Expiration Year',
  unlimited_group_creation_title: 'Name Group',
  unlimited_create_group_description:
    'Add members so that everyone gets the maximum benefits of the NEXT+ / Unlimited plan',
  unlimited_creation_sms_confirmation:
    'Each of the members who have given consent will automatically switch to the NEXT+ / Unlimited rate plan and must stay in the group for a minimum of 3 months.',
  unlimited_group_name_description: 'Name group and add up to %1$s members',
  unlimited_group_name_label: 'Group Name',
  unlimited_installation_title: 'Installation',
  unlimited_installation_description:
    'Select preferred date for the installation visit',
  unlimited_installation_fee_title: 'Installation Fee',
  unlimited_installation_fee_subtitle:
    'This fee will be paid in the first bill',
  unlimited_installation_fee_label: 'First time installation fee',
  unlimited_summary_selection_title: 'Shtëpia Jonë',
  unlimited_summary_members_description: 'View group members.',
  unlimited_summary_cost_total: 'Total cost',
  unlimited_summary_cost_subtitle: 'Price and Validity',
  unlimited_summary_amount: '%1$s Lekë ',
  unlimited_summary_monthly: 'Monthly Fee',
  unlimited_summary_cost_start: 'Start Date',
  unlimited_summary_cost_duration: 'Duration',
  unlimited_summary_cost_cancel_period: 'Deadline for changing members',
  unlimited_summary_plan_monthly: 'Monthly Fee',
  unlimited_summary_plan_firstBill: 'First Bill',
  unlimited_summary_duration: '%1$s month',
  unlimited_cancel_duration: '6 months',
  unlimited_per_month: '%1$s Lekë per month',
  unlimited_summary_why: 'Why?',
  unlimited_summary_breakdown: 'Details',
  unlimited_summary_discount: 'Discount',
  unlimited_summary_modem_deposit: 'Device fee',
  unlimited_summary_installation_fee: 'Installation Fee',
  unlimited_summary_total_to_pay: 'Total to be paid',
  unlimited_summary_first_bill: 'First Bill',
  unlimited_summary_recurring: 'Monthly total (for %1$s months)',
  unlimited_summary_confirm_button: 'Confirm',
  unlimited_summary_tos_p1: "By pressing  'Confirm', you agree to ",
  unlimited_summary_tos_p2: 'the terms and conditions. ',
  unlimited_close: 'Close',
  unlimited_explain_dialog_title: 'Why my bill is %1$s Lekë?',
  unlimited_marked_for_leave: 'Waiting to leave',
  unlimited_explain_dialog_explanation:
    'The first bill will include the installation fee, device fee and the monthly fee from the date of receiving the service',
  unlimited_total: 'Total',
  unlimited_home_recommended: 'Recommendation for you',
  unlimited_camera_continue: 'Continue',
  unlimited_camera_retake_photo: 'Redo picture',
  unlimited_camera_selfie: 'Take a picture of your portrait',
  unlimited_camera_back_id: 'Take a picture of the back of your ID',
  unlimited_camera_front_id: 'Take a picture of the front of your ID',
  unlimited_members_count: '%1$s/%1$s',
  unlimited_no_members_placeholder: 'The group will be created without members',
  unlimited_members_placeholder:
    'Each of the members will be notified with a SMS and must give their consent within 48 hours to join the group',
  unlimited_number_already_added: 'This number is already part of your group',
  unlimited_invalid_group_name: 'Please name your group',
  unlimited_group_name_length_min:
    'The group name should have at least 2 characters',
  unlimited_group_name_length_max:
    'The group name should have less than 10 characters',
  unlimited_member_success_added: '* successfully added',
  unlimited_admin_member: 'Administrator',
  unlimited_grace_period_status: 'Can be modified after %1$s',
  unlimited_filled_slots: '* You have filled all your free slots',
  unlimited_error: 'An error occurred',
  unlimited_error_adding_title: 'Error adding member',
  unlimited_try_again: 'Try again',
  unlimited_continue_without_member: 'Continue without this number',
  unlimited_rename_group_title: 'Modify group',
  unlimited_rename_group_header: 'Change group name',
  unlimited_rename_group_desc: 'Change your group name',
  unlimited_invalid_id: 'Personal name is mandatory',
  unlimited_invalid_name: 'Name is mandatory',
  unlimited_invalid_email: 'Email is invalid',
  unlimited_invalid_number: 'Incorrect phone number format',
  unlimited_invalid_surname: 'Surname is mandatory',
  unlimited_admin_number: "The administrator can't be added as group member",
  unlimited_already_added:
    ' The member with this number has been added to the group ',
  unlimited_create_plan: 'Create offer',
  unlimited_create_description: 'Choose tariff plan, speed and members',
  unlimited_first_benefit: 'Create the product for the whole house',
  unlimited_second_benefit: 'Pricing and usage flexibility',
  unlimited_third_benefit: 'Get and pay all services in 1 bill',
  unlimited_choose_plan_title: 'Choose tariff plan ',
  unlimited_choose_speed_title: 'Choose Vodafone Giga Fibra',
  unlimited_choose_speed_sub:
    'Experience the speed of Network No. 1 in Albania',
  unlimited_choose_tv_title: 'Choose Vodafone Giga TV',
  unlimited_choose_tv_sub: 'Fun like never before',
  unlimited_choose_slots_title: 'Select number of members',
  unlimited_slots_count: '%1$s member',
  unlimited_valid_until: 'Offer valid until %1$s',
  unlimited_save: 'Save %1$s Lekë',
  unlimited_go_back_to_offers: 'Go back to the recommended offers',
  unlimited_view_cart_title:
    'Explore endless family solutions and possibilities',
  unlimited_view_cart_cta: 'View Products',
  unlimited_cart_details_title: 'Personalized Offer',
  unlimited_cart_details_subtitle: 'My Products',
  unlimited_mobile_plan: 'Mobile Plan',
  unlimited_national_calls: 'National Calls',
  unlimited_national_sms: 'National SMS',
  unlimited_internet: 'Internet',
  unlimited_minutes: '%1$s MIN',
  unlimited_sms_count: '%1$s SMS',
  unlimited_gb: '%1$s GB',
  unlimited_mbps: '%1$s Mbps',
  unlimited_prefer_time: 'Select schedule:',
  unlimited_morning_time: 'Morning',
  unlimited_noon_time: 'Noon',
  unlimited_afternoon_time: 'Afternoon',
  unlimited_unable_to_add: "Member %1$s couldn't be added.",
  unlimited_one_admin: '\u2022    1 administrator',
  unlimited_slots_count_list: '\u2022    %1$s members',
  unlimited_tv_name: 'TV %1$s',
  unlimited_channel_count: '%1$s Fun like never before',
  unlimited_channel_count_list: '\u2022    %1$s Fun like never before',
  unlimited_more_benefits: 'Benefits',
  unlimited_standard_offers: 'Standard Offers',
  unlimited_speed: 'Speed',
  unlimited_your_group: 'Your Group',
  unlimited_added_members: '%1$s members added',
  unlimited_details: 'Details of Shtepia Jone',
  unlimited_vf_internet: 'Vodafone Giga Fibra',
  unlimited_plan_period: '%1$s month contract',
  unlimited_plan_roaming: 'RED roaming',
  unlimited_plan_vcoins: 'Double Vcoins',
  unlimited_offer_deselect_button: 'Remove this option',
  unlimited_order_success_modal: 'New broadband line',
  unlimited_order_success_title: 'Order completed',
  unlimited_order_success_desc:
    'Installers will visit the address within 48 hours. We will notify you by SMS when the installation is complete and the offer is valid',
  unlimited_order_error_modal: 'An error ocurred',
  unlimited_unselect_internet: 'Continue without internet',
  unlimited_unselect_members: 'Continue without members',
  unlimited_usage_terms: 'Usage Details',
  unlimited_coverage_error: 'An error occurred while verifying coverage.',
  unlimited_customer_check_error:
    'An error occurred while verifying the customer',
  unlimited_plan_select_button: 'Select this plan',
  unlimited_plan_selected_button: 'Selected Plan',
  unlimited_id_helper_text:
    'Enter the personal 10-digit number of the identity card',
  unlimited_validating: 'Verifying data',
  unlimited_member_pay_explain:
    'Members will pay the additional expenses themselves, such as: additional packages, roaming, parking, etc.',
  unlimited_terms_and_conditions: 'Terms and conditions',
  unlimited_city: 'Birthplace',
  unlimited_gender: 'Gender',
  unlimited_male: 'Male',
  unlimited_else: 'Other',
  unlimited_female: 'Female',
  unlimited_birthday_day: 'Day',
  unlimited_birthday_year: 'Year',
  unlimited_birthday_month: 'Month',
  unlimited_home_birthday: 'Birthday',
  unlimited_birthday_year_error: 'Birth year is not correct',
  unlimited_birthday_month_error: 'Month is not correct',
  unlimited_birthday_day_error: 'Date is not correct'
}

export default en
